<ng-container *ngIf="form" [formGroup]="form">
	<div class="filter-bar">
		<div class="filter-bar__search">
			<app-textbox formControlName="fullName" placeholder="Поиск по ФИО" i18n-placeholder></app-textbox>
		</div>
		<button
			i18n
			type="button"
			appSkin="simple-gray no-shadow bold"
			(click)="resetFilter()"
			[disabled]="!form?.get('fullName')?.value">
			Сбросить
		</button>
	</div>
</ng-container>
